import React, { useState } from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useToast } from '../hooks/use-toast';
import { Loader2, ArrowRight, Shield, Clock, Award } from 'lucide-react';

const countryCodes = [
  { code: '+1', flag: '\u{1f1fa}\u{1f1f8}' }, { code: '+44', flag: '\u{1f1ec}\u{1f1e7}' },
  { code: '+91', flag: '\u{1f1ee}\u{1f1f3}' }, { code: '+86', flag: '\u{1f1e8}\u{1f1f3}' },
  { code: '+81', flag: '\u{1f1ef}\u{1f1f5}' }, { code: '+49', flag: '\u{1f1e9}\u{1f1ea}' },
  { code: '+33', flag: '\u{1f1eb}\u{1f1f7}' }, { code: '+61', flag: '\u{1f1e6}\u{1f1fa}' },
  { code: '+55', flag: '\u{1f1e7}\u{1f1f7}' }, { code: '+52', flag: '\u{1f1f2}\u{1f1fd}' },
  { code: '+82', flag: '\u{1f1f0}\u{1f1f7}' }, { code: '+34', flag: '\u{1f1ea}\u{1f1f8}' },
  { code: '+39', flag: '\u{1f1ee}\u{1f1f9}' }, { code: '+31', flag: '\u{1f1f3}\u{1f1f1}' },
  { code: '+46', flag: '\u{1f1f8}\u{1f1ea}' }, { code: '+41', flag: '\u{1f1e8}\u{1f1ed}' },
  { code: '+65', flag: '\u{1f1f8}\u{1f1ec}' }, { code: '+971', flag: '\u{1f1e6}\u{1f1ea}' },
  { code: '+966', flag: '\u{1f1f8}\u{1f1e6}' }, { code: '+27', flag: '\u{1f1ff}\u{1f1e6}' },
  { code: '+64', flag: '\u{1f1f3}\u{1f1ff}' }, { code: '+48', flag: '\u{1f1f5}\u{1f1f1}' },
  { code: '+90', flag: '\u{1f1f9}\u{1f1f7}' }, { code: '+62', flag: '\u{1f1ee}\u{1f1e9}' },
  { code: '+63', flag: '\u{1f1f5}\u{1f1ed}' }, { code: '+66', flag: '\u{1f1f9}\u{1f1ed}' },
  { code: '+60', flag: '\u{1f1f2}\u{1f1fe}' }, { code: '+84', flag: '\u{1f1fb}\u{1f1f3}' },
  { code: '+92', flag: '\u{1f1f5}\u{1f1f0}' }, { code: '+880', flag: '\u{1f1e7}\u{1f1e9}' },
  { code: '+234', flag: '\u{1f1f3}\u{1f1ec}' }, { code: '+254', flag: '\u{1f1f0}\u{1f1ea}' },
  { code: '+353', flag: '\u{1f1ee}\u{1f1ea}' }, { code: '+43', flag: '\u{1f1e6}\u{1f1f9}' },
  { code: '+32', flag: '\u{1f1e7}\u{1f1ea}' }, { code: '+45', flag: '\u{1f1e9}\u{1f1f0}' },
  { code: '+358', flag: '\u{1f1eb}\u{1f1ee}' }, { code: '+30', flag: '\u{1f1ec}\u{1f1f7}' },
  { code: '+972', flag: '\u{1f1ee}\u{1f1f1}' }, { code: '+56', flag: '\u{1f1e8}\u{1f1f1}' },
  { code: '+57', flag: '\u{1f1e8}\u{1f1f4}' }, { code: '+54', flag: '\u{1f1e6}\u{1f1f7}' },
  { code: '+974', flag: '\u{1f1f6}\u{1f1e6}' }, { code: '+965', flag: '\u{1f1f0}\u{1f1fc}' },
  { code: '+852', flag: '\u{1f1ed}\u{1f1f0}' }, { code: '+886', flag: '\u{1f1f9}\u{1f1fc}' },
  { code: '+7', flag: '\u{1f1f7}\u{1f1fa}' }, { code: '+20', flag: '\u{1f1ea}\u{1f1ec}' },
  { code: '+212', flag: '\u{1f1f2}\u{1f1e6}' }, { code: '+351', flag: '\u{1f1f5}\u{1f1f9}' },
  { code: '+36', flag: '\u{1f1ed}\u{1f1fa}' }, { code: '+420', flag: '\u{1f1e8}\u{1f1ff}' },
  { code: '+40', flag: '\u{1f1f7}\u{1f1f4}' }, { code: '+380', flag: '\u{1f1fa}\u{1f1e6}' },
  { code: '+98', flag: '\u{1f1ee}\u{1f1f7}' }, { code: '+51', flag: '\u{1f1f5}\u{1f1ea}' },
  { code: '+593', flag: '\u{1f1ea}\u{1f1e8}' }, { code: '+968', flag: '\u{1f1f4}\u{1f1f2}' },
  { code: '+973', flag: '\u{1f1e7}\u{1f1ed}' }, { code: '+94', flag: '\u{1f1f1}\u{1f1f0}' },
  { code: '+977', flag: '\u{1f1f3}\u{1f1f5}' }, { code: '+233', flag: '\u{1f1ec}\u{1f1ed}' },
  { code: '+213', flag: '\u{1f1e9}\u{1f1ff}' }, { code: '+216', flag: '\u{1f1f9}\u{1f1f3}' },
  { code: '+961', flag: '\u{1f1f1}\u{1f1e7}' }, { code: '+962', flag: '\u{1f1ef}\u{1f1f4}' },
  { code: '+964', flag: '\u{1f1ee}\u{1f1f6}' }, { code: '+993', flag: '\u{1f1f9}\u{1f1f2}' },
  { code: '+58', flag: '\u{1f1fb}\u{1f1ea}' }, { code: '+47', flag: '\u{1f1f3}\u{1f1f4}' },
  { code: '+853', flag: '\u{1f1f2}\u{1f1f4}' },
];

const ContactFormDialog = ({ isOpen, onClose }) => {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', countryCode: '+1', phone: '', description: '' });
  const [errors, setErrors] = useState({ email: '', phone: '' });

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = { email: '', phone: '' };
    let hasErrors = false;
    if (!validateEmail(formData.email)) { newErrors.email = 'Enter a valid email'; hasErrors = true; }
    if (formData.phone.length !== 10) { newErrors.phone = 'Phone must be 10 digits'; hasErrors = true; }
    if (hasErrors) { setErrors(newErrors); return; }
    setIsSubmitting(true);
    setTimeout(() => {
      toast({ title: "Request Submitted!", description: "Our team will reach out within 24 hours." });
      setIsSubmitting(false);
      setFormData({ name: '', email: '', countryCode: '+1', phone: '', description: '' });
      setErrors({ email: '', phone: '' });
      onClose();
    }, 1500);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent data-testid="contact-form-dialog" className="max-w-[880px] p-0 gap-0 overflow-hidden rounded-none border-[#E5E7EB]">
        <div className="flex flex-col md:flex-row">
          {/* Left Dark Panel */}
          <div className="hidden md:flex w-[38%] relative p-8 flex-col justify-between overflow-hidden">
            <img src="https://images.unsplash.com/photo-1764410481612-7544525b2991?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxkYXJrJTIwY29ycG9yYXRlJTIwbGVnYWwlMjBvZmZpY2UlMjBkZXNrJTIwbHV4dXJ5fGVufDB8fHx8MTc3NTUxNTE1OXww&ixlib=rb-4.1.0&q=85" alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-[#0A0F1C]/80" />
            <div className="relative z-10">
              <span className="inline-block bg-[#002FA7] text-white text-[10px] font-medium uppercase tracking-widest px-3 py-1.5 mb-6">Starting at $49</span>
              <h3 className="text-xl font-bold tracking-tight mb-3 leading-tight text-white">Expert Trademark Registration</h3>
              <p className="text-sm text-gray-400 leading-relaxed">Professional attorneys to protect your brand identity nationwide.</p>
            </div>
            <div className="flex flex-col gap-4 mt-8 relative z-10">
              {[{ icon: Shield, label: 'Federal Protection' }, { icon: Clock, label: 'Fast Processing' }, { icon: Award, label: 'Expert Attorneys' }].map(({ icon: Icon, label }, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 border border-gray-700 flex items-center justify-center"><Icon className="w-4 h-4 text-[#002FA7]" /></div>
                  <span className="text-xs font-medium text-gray-300 uppercase tracking-wider">{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Form */}
          <div className="w-full md:w-[62%] p-6 md:p-8 bg-white">
            <div className="mb-5">
              <h2 className="text-lg font-bold text-[#0A0F1C] mb-1">Get Your Free Consultation</h2>
              <p className="text-sm text-[#4B5563]">Fill in your details and our team will reach out within 24 hours.</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <Label className="text-[#0A0F1C] text-xs font-medium uppercase tracking-wider">Full Name *</Label>
                <Input data-testid="dialog-name-input" placeholder="Enter your full name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required className="h-9 rounded-none border-[#E5E7EB] bg-[#F8F9FA] focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20 mt-1" />
              </div>
              <div>
                <Label className="text-[#0A0F1C] text-xs font-medium uppercase tracking-wider">Email *</Label>
                <Input data-testid="dialog-email-input" type="email" placeholder="your@email.com" value={formData.email} onChange={(e) => { setFormData({ ...formData, email: e.target.value }); setErrors({ ...errors, email: '' }); }} required className={`h-9 rounded-none bg-[#F8F9FA] mt-1 ${errors.email ? 'border-[#FF2A00]' : 'border-[#E5E7EB]'} focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20`} />
                {errors.email && <p className="text-[#FF2A00] text-xs mt-1">{errors.email}</p>}
              </div>
              <div>
                <Label className="text-[#0A0F1C] text-xs font-medium uppercase tracking-wider">Phone *</Label>
                <div className="flex gap-2 mt-1">
                  <Select value={formData.countryCode} onValueChange={(v) => setFormData({ ...formData, countryCode: v })}>
                    <SelectTrigger data-testid="dialog-country-select" className="w-[100px] h-9 rounded-none border-[#E5E7EB] bg-[#F8F9FA]"><SelectValue /></SelectTrigger>
                    <SelectContent className="max-h-[300px]">{countryCodes.map((item) => (<SelectItem key={item.code} value={item.code}><span className="flex items-center gap-2"><span>{item.flag}</span><span>{item.code}</span></span></SelectItem>))}</SelectContent>
                  </Select>
                  <Input data-testid="dialog-phone-input" type="tel" placeholder="1234567890" value={formData.phone} onChange={(e) => { const d = e.target.value.replace(/\D/g, ''); if (d.length <= 10) { setFormData({ ...formData, phone: d }); setErrors({ ...errors, phone: '' }); } }} required maxLength={10} className={`flex-1 h-9 rounded-none bg-[#F8F9FA] ${errors.phone ? 'border-[#FF2A00]' : 'border-[#E5E7EB]'} focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20`} />
                </div>
                {errors.phone && <p className="text-[#FF2A00] text-xs mt-1">{errors.phone}</p>}
              </div>
              <div>
                <Label className="text-[#0A0F1C] text-xs font-medium uppercase tracking-wider">What do you need?</Label>
                <Textarea data-testid="dialog-description-input" placeholder="e.g. Register my brand for Amazon" rows={2} value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} className="rounded-none border-[#E5E7EB] bg-[#F8F9FA] focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20 resize-none mt-1" />
              </div>
              <Button type="submit" data-testid="dialog-submit-button" className="w-full bg-[#002FA7] hover:bg-[#002280] text-white font-medium h-10 rounded-none text-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,47,167,0.3)]" disabled={isSubmitting}>
                {isSubmitting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Submitting...</> : <>Submit Request <ArrowRight className="ml-2 w-4 h-4" /></>}
              </Button>
              <p className="text-[10px] text-[#4B5563] text-center">By submitting, you agree to our Terms and Privacy Policy.</p>
            </form>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactFormDialog;
